import URI from 'urijs';
import { checktype, checkmap, objDrilldown } from './utils.js';
import { rreplace as Drreplace } from './directives.js';
import { stateAbbrReverseMap } from './stateAbbrMap.js';
import {
  sameDay as dtSameDay,
  sameMonth as dtSameMonth,
  sameYear as dtSameYear,
  ltimef as dtLtimef,
  ltimestampf as dtLtimestampf,
  timef as dtTimef,
  timestampf as dtTimestampf
} from './datetime.js';

export const imageNoop = (string) => {
  return string;
}

export const imageCloudinary = imageNoop;

export const ldatetimef = () => {
  // TODO Implement lnumberf
  missing('missing ldatetimef');
};

export const rreplace = Drreplace;

export const parseInt = (value) => {
  checktype(value, 'string');
  return parseInt(value);
};

export const parseFloat = (value) => {
  checktype(value, 'string');
  return parseFloat(value);
};

export const contains = (list, value) => {
  checktype(list, 'array');
  return list.filter(item => item === value).length > 0;
};

export const indexOf = (haystack, needle) => {
  checktype(haystack, 'string');
  checktype(needle, 'string');
  return haystack.indexOf(needle);
};

export const augmentList = (list1, list2) => {
  checktype(list1, 'array');
  checktype(list2, 'array');
  return list1.concat(list2);
};

export const collapseDays = (hours) => {
  checktype(hours, 'array');

  if (hours.length === 0) {
    return hours;
  }

  let output = [hours[0]];
  for (let i = 1, end = hours.length, asc = 1 <= end; asc ? i < end : i > end; asc ? i++ : i--) {
    let cur = hours[i];
    let prev = output[output.length - 1];
    if (dayHoursEquals(prev, cur) && (cur['holiday'] === undefined) && (prev['holiday'] === undefined)) {
      prev['through'] = cur['day'];
    } else {
      output.push(cur);
    }
  }

  return output;
};

export let dayHoursEquals = function(i1, i2) {
  checkmap(i1);
  checkmap(i2);

  let l1 = i1['intervals'];

  // If not intervals, assume it's a daily time
  if (l1 === undefined) {
    return i1['time'] === i2['time'];
  }

  let l2 = i2['intervals'];

  if (l1.length !== l2.length) {
    return false;
  }

  for (let i = 0, end = l1.length, asc = 0 <= end; asc ? i < end : i > end; asc ? i++ : i--) {
    if ((l1[i]['start'] !== l2[i]['start']) || (l1[i]['end'] !== l2[i]['end'])) {
      return false;
    }
  }

  return true;
};

export const gmap = (path,params) => privatem("gmap");

export const dynamicImageBySize = (sizes, width, height, atLeastAsLarge) => {
  if (atLeastAsLarge == null) { atLeastAsLarge = true; }
  checktype(sizes, 'array');
  checktype(width, 'number');
  checktype(height, 'number');
  checktype(atLeastAsLarge, 'boolean');
  if (sizes.length === 0) { throw new Error("non-zero length sizes array required"); }
  if (sizes.length > 1) {
    let w = width > 0 ? width : '';
    let h = height > 0 ? height : '';
    let desiredSize = `${w}x${h}`;
    return imageBySize(sizes, desiredSize, atLeastAsLarge);
  }

  let getLocation = function(href) {
    // source : http://stackoverflow.com/questions/736513/how-do-i-parse-a-url-into-hostname-and-path-in-javascript
    // native url parsing browser support is quite poor
    let match = href.match(/^(https?:)?\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
    return match &&{
      protocol: match[1] || "",
      host: match[2] || "",
      hostname: match[3] || "",
      port: match[4] || "",
      pathname: match[5] || "",
      search: match[6] || "",
      hash: match[7] || ""
    };
  };

  let parsed = getLocation(sizes[0].url);

  if (atLeastAsLarge) {
    parsed.hostname = "dynl.mktgcdn.com";
  } else {
    parsed.hostname = "dynm.mktgcdn.com";
  }

  let pathParts = parsed.pathname.split('/');
  let filename = pathParts.pop();
  let ext = filename.split('.').pop();
  let newfilename = `${width}x${height}.${ext}`;
  pathParts.push(newfilename);
  parsed.pathname = pathParts.join('/');

  return `${parsed.protocol}//${parsed.hostname}${parsed.port}${parsed.pathname}${parsed.search}${parsed.hash}`;
};

export function imageBySize (sizes, desiredSize, atLeastAsLarge) {
  let height, index;
  if (atLeastAsLarge == null) { atLeastAsLarge = true; }
  checktype(sizes, 'array');
  checktype(desiredSize, 'string');
  if (desiredSize.indexOf('x') === -1) {
    throw new Error("Invalid desired size");
  }
  checktype(atLeastAsLarge, 'boolean');

  let width = (height = -1);

  let desiredDims = desiredSize.split('x');

  if (desiredDims[0] !== '') {
    width = Number.parseInt(desiredDims[0]);
    if (Number.isNaN(width)) {
      throw new Error("Invalid width specified");
    }
  }

  if (desiredDims[1] !== '') {
    height = Number.parseInt(desiredDims[1]);
    if (Number.isNaN(height)) {
      throw new Error("Invalid height specified");
    }
  }

  let widthOk = width === -1;
  let heightOk = height === -1;

  if (atLeastAsLarge) {
    index = sizes.length - 1;

    while (index >= 0) {
      if (width > 0) {
        widthOk = (sizes[index].width >= width);
      }

      if (height > 0) {
        heightOk = (sizes[index].height >= height);
      }

      if (heightOk && widthOk) {
        break;
      }

      index--;
    }

    // if we exhausted the list
    if (index <= 0) {
      index = 0;
    }

  } else {
    index = 0;

    while (index < sizes.length) {
      if (width > 0) {
        widthOk = sizes[index].width <= width;
      }

      if (height > 0) {
        heightOk = sizes[index].height <= height;
      }

      if (heightOk && widthOk) { break; }

      index++;
    }

    // if we exhausted the list
    if (index >= sizes.length) {
      index = sizes.length - 1;
    }
  }

  return sizes[index].url;
}


export const prettyPrintPhone = (rawPhoneNumber) => {
  checktype(rawPhoneNumber, 'string');
  if (rawPhoneNumber.length !== 10) {
    return rawPhoneNumber;
  } else {
    return `(${rawPhoneNumber.substring(0, 3)}) ${rawPhoneNumber.substring(3, 6)}-${rawPhoneNumber.substring(6, 10)}`;
  }
};


export const replace = (string, old, snew, max) => {
  if (max == null) { max = -1; }
  checktype(string, 'string');
  checktype(old, 'string');
  checktype(snew, 'string');
  checktype(max, 'number');

  if ((max === 0) || (old === snew)) {
    return string;
  }

  if (max === -1) {
    return string.replace(new RegExp(old, 'g'), snew);
  }

  let output = '';
  for (let i = 0, end = max-1, asc = 0 <= end; asc ? i <= end : i >= end; asc ? i++ : i--) {
    let nextInstance = string.indexOf(old);
    if (nextInstance !== -1) {
      output += string.substring(0, nextInstance) + snew;
      string = string.substring(nextInstance + old.length);
    }
  }

  output += string;
  return output;
};

export const listItems = (list) => {
  checktype(list, 'array');
  const reduceByKey = (list, key) => list.reduce(
    (a, b) => a.concat(b[key]), []
  );
  return reduceByKey(reduceByKey(list, 'sections'), 'items');
}

export const groupListByKey = (list, key) => {
  checktype(list, 'array');
  checktype(key, 'string');

  let groups = [];
  let sorted = sortListByKeys(list, [key]);
  for (let obj of Array.from(sorted)) {
    var currentgroup;
    let currentkey = objDrilldown(obj, key);

    if (currentkey !== currentgroupkey) {
      var currentgroupkey = currentkey;
      currentgroup = {'key': currentgroupkey, 'vals': []};
      groups.push(currentgroup);
    }
    currentgroup['vals'].push(obj);
  }

  return groups;
};

export const groupListByKeyMap = (list, key) => {
  checktype(list, 'array');
  checktype(key, 'string');

  let groups = {};
  let sorted = sortListByKeys(list, [key]);

  for (let obj of Array.from(sorted)) {
    var currentgroup, currentgroupkey;
    let currentkey = objDrilldown(obj, key);

    if (currentkey !== currentgroupkey) {
      currentgroupkey = currentkey;
      currentgroup = [];
    }
    currentgroup.push(obj);
    groups[currentgroupkey] = currentgroup;
  }

  return groups;
};

export const sortListByKeys = (list, sorts) => {
  checktype(list, 'array');
  if (list.length === 0) { return []; }
  checktype(sorts, 'array');
  if (sorts.length === 0) { return list; }

  let compare = function(fields){
    let nfields = fields.length;

    return function(loc1, loc2) {
      let result;
      let i = 0;
      while (i < nfields) {
        result = 0;
        let field = fields[i];
        let descending = field.charAt(0) === '-';
        if (descending) { field = field.substring(1); }
        let reverse = descending ? -1 : 1;
        let a = objDrilldown(loc1, field);
        let b = objDrilldown(loc2, field);
        if ((typeof a) == 'string' && (typeof b) == 'string') {
          if (a.localeCompare(b) < 0) {
            result = reverse * -1;
          }
          if (a.localeCompare(b) > 0) {
            result = reverse * 1;
          }
        } else {
          if (a < b) {
            result = reverse * -1;
          }
          if (a > b) {
            result = reverse * 1;
          }
        }
        
        if (result !== 0) {
          break;
        }
        i++;
      }
      return result;
    };
  };

  let sorted = list.sort(compare(sorts));
  return sorted;
};

export const sortList = (list, ascending) => {
  if (ascending == null) { ascending = true; }
  checktype(list, 'array');
  if (list.length === 0) { return []; }

  let sentinelType = typeof list[0];

  if (!['number', 'boolean', 'string'].includes(sentinelType)) {
    throw new Error('Expected a list of primitive types');
  }

  if (list.length === 1) { return [list[0]]; }
  ascending = ascending ? 1 : -1;

  for (let item of list) {
    checktype(item, sentinelType);
  }

  let compare = function(a, b) {
    let result = 0;
    switch (typeof a) {
      case 'string': {
        if (a.localeCompare(b) < 0) {
          result = -1 * ascending;
        }
        if (a.localeCompare(b) > 0) {
          result = 1 * ascending;
        }
        break;
      }
      default: {
        if (a < b) {
          result = -1 * ascending;
        }
        if (a > b) {
          result = 1 * ascending;
        }
      }
    }
    return result;
  };

  return list.sort(compare);
};

export const lnumberf = (locale, number) =>
  // TODO Implement lnumberf
  missing("lnumberf")
;
export const lpercentf = (locale, number) =>
  // TODO Implement lpercentf
  missing("lpercentf")
;
export const lcurrencyf = (locale, currency, number) =>
  // TODO Implement lcurrencyf
  missing("lcurrencyf")
;
export const llanguageName = (locale, language) =>
  // TODO Implement llanguageName
  missing("llanguageName")
;
export const lcountryName = (locale, country) =>
  // TODO Implement lcountryName
  missing("lcountryName")
;
export const llocaleName = (locale, targetlocale) =>
  // TODO Implement llocaleName
  missing("llocaleName")
;
export const lregionName = (locale, country, region) =>
  // TODO Implement lregionName
  missing("lregionName")
;
export const ltimezone = () =>
  // TODO Implement ltimezone
  missing("ltimezone");
;

export const imageBySizeCloudinary = imageBySize;

export const imageBySizeDynamic = () =>
  // TODO Implement imageBySizeDynamic
  missing("imageBySizeDynamic");
;

export const imageDynamic = () =>
  // TODO Implement imageDynamic
  missing("imageDynamic");
;
// Takes in a string and strips out all the pretty parts of it. If the first character is a +,
// it will keep it. Apart from that, it strips out all non-numeric characters.
export const stripOutPhoneDigits = (phone) => {
  checktype(phone, 'string');
  return phone.replace(/(?!\+)\D/g,'');
};

export const strlen = (string) => {
  checktype(string, 'string');
  return string.length;
};

export const substring = (string, start, end) => {
  if (end == null) { end = -1; }
  checktype(string, 'string');
  return string.substring(start, end === -1 ? string.length : end);
};

export const sameDay = dtSameDay;
export const sameMonth = dtSameMonth;
export const sameYear = dtSameYear;
export const ltimef = dtLtimef;
export const ltimestampf = dtLtimestampf;
export const timef = dtTimef;
export const timestampf = dtTimestampf;

export const slice = (elems, start, end) => {
  if (end == null) {
    end = elems.length-1;
  }
  return elems.slice(start, end);
};

export const fullState = (abbr) => {
  checktype(abbr, 'string');
  let lookup = stateAbbrReverseMap[abbr];
  if (lookup) { return lookup; } else { return abbr; }
};

export const parseURL = (url) => {
  checktype(url, 'string');
  let parsedURL = new URI(url);
  return {
    "scheme": parsedURL.scheme(),
    "host": parsedURL.host(),
    "hostname": parsedURL.hostname(),
    "port": parsedURL.port(),
    "path": parsedURL.path(),
    "query": parsedURL.query(),
    "fragment": parsedURL.fragment(),
  };
}

let Funcs = {};
Funcs.imageNoop = imageNoop;
Funcs.imageCloudinary = imageCloudinary;
Funcs.ldatetimef = ldatetimef;
Funcs.rreplace = rreplace;
Funcs.parseInt = parseInt;
Funcs.parseFloat = parseFloat;
Funcs.contains = contains;
Funcs.indexOf = indexOf;
Funcs.augmentList = augmentList;
Funcs.collapseDays = collapseDays;
Funcs.dayHoursEquals = dayHoursEquals;
Funcs.gmap = gmap;
Funcs.dynamicImageBySize = dynamicImageBySize;
Funcs.imageBySize = imageBySize;
Funcs.prettyPrintPhone = prettyPrintPhone;
Funcs.replace = replace;
Funcs.listItems = listItems;
Funcs.groupListByKey = groupListByKey;
Funcs.groupListByKeyMap = groupListByKeyMap;
Funcs.sortListByKeys = sortListByKeys;
Funcs.sortList = sortList;
Funcs.lnumberf = lnumberf;
Funcs.lpercentf = lpercentf;
Funcs.lcurrencyf = lcurrencyf;
Funcs.llanguageName = llanguageName;
Funcs.lcountryName = lcountryName;
Funcs.llocaleName = llocaleName;
Funcs.lregionName = lregionName;
Funcs.ltimezone = ltimezone;
Funcs.imageBySizeCloudinary = imageBySizeCloudinary;
Funcs.imageBySizeDynamic = imageBySizeDynamic;
Funcs.imageDynamic = imageDynamic;
Funcs.stripOutPhoneDigits = stripOutPhoneDigits;
Funcs.strlen = strlen;
Funcs.substring = substring;
Funcs.sameDay = sameDay;
Funcs.sameMonth = sameMonth;
Funcs.sameYear = sameYear;
Funcs.ltimef = ltimef;
Funcs.ltimestampf = ltimestampf;
Funcs.timef = timef;
Funcs.parseURL = parseURL;

export {
  Funcs
}
